import LZString from "lz-string";

export const compressToUTF16 = LZString.compressToUTF16;
export const decompressFromUTF16 = LZString.decompressFromUTF16;
